import { GRID_PATTERN_IDS } from '~/composables/grid/constants'

export type PanelVariantName = 'square' | '45-square' | 'hex' | '90-hex' | 'spaced-hex' | 'freeform' | '3d'
export type PanelSection = 'project-details' | 'rotation' | 'shapes' | 'engraved-tiles' | '3d-blocks'
export type ShapeGroupTreatment = 'available-and-other' | 'available-only' | 'all-available'

export interface PanelVariant {
  name: PanelVariantName
  figmaNodeId: string
  sections: readonly PanelSection[]
  shapeGroups: ShapeGroupTreatment
  projectDetails: true
  liveColors: true
}

const variant = (name: PanelVariantName, figmaNodeId: string, sections: readonly PanelSection[], shapeGroups: ShapeGroupTreatment): PanelVariant => ({
  name, figmaNodeId, sections, shapeGroups, projectDetails: true, liveColors: true,
})

export const PANEL_VARIANTS: Record<GRID_PATTERN_IDS, PanelVariant> = {
  [GRID_PATTERN_IDS.SQUARE]: variant('square', '2850:163596', ['project-details', 'shapes'], 'available-and-other'),
  [GRID_PATTERN_IDS.SQUARE_45]: variant('45-square', '2850:163599', ['project-details', 'shapes'], 'available-only'),
  [GRID_PATTERN_IDS.HEX]: variant('hex', '2850:163595', ['project-details', 'shapes'], 'available-and-other'),
  [GRID_PATTERN_IDS.HEX_90]: variant('90-hex', '2850:163598', ['project-details', 'shapes', 'engraved-tiles'], 'available-and-other'),
  [GRID_PATTERN_IDS.HEX_SPACED]: variant('spaced-hex', '2850:163593', ['project-details', 'shapes', 'engraved-tiles'], 'available-and-other'),
  [GRID_PATTERN_IDS.FREEFORM]: variant('freeform', '2850:163594', ['project-details', 'rotation', 'shapes'], 'all-available'),
  [GRID_PATTERN_IDS.THREE_D]: variant('3d', '2850:163597', ['project-details', '3d-blocks'], 'available-only'),
}

export const resolvePanelVariant = (patternId?: string | null): PanelVariant =>
  PANEL_VARIANTS[patternId as GRID_PATTERN_IDS] || PANEL_VARIANTS[GRID_PATTERN_IDS.SQUARE]
